export const getMin = (intervals: any): number => {
  return intervals.reduce((min: any, interval: any) => interval.minValue < min ? interval.minValue : min, intervals[0].minValue);
};
export const getMax = function(intervals: any): number {
  return intervals.reduce((max: any, interval: any) => interval.maxValue > max ? interval.maxValue : max, intervals[0].maxValue);
};
